import createUserModel from 'f-app-models/createUserModel'

export const user = createUserModel(process.env.REACT_APP_STRIPE_KEY, process.env.REACT_APP_SERVER_URL)
export * from 'f-app-models'
export {default as settings} from './settings'
